import { Observable } from 'rxjs/Rx'
import { createSlice } from '@reduxjs/toolkit'
import * as authenticationDuck from 'store/ducks/authentication'
import { combineEpics } from 'redux-observable'
import { rides } from '../services/ride'
import { GlobalState } from './state'
import { Ride } from 'interfaces/ride'
import { EditionSatus } from 'interfaces/common'

export type RidesState = {
  isLoading: boolean
  currentRide: Ride | null
  isThreadCreated: boolean
  ridesList: Ride[]
  totalRides: number
  modalStatus: EditionSatus
}

const INITIAL_STATE = {
  ridesList: [],
  currentRide: null,
  isThreadCreated: false,
  isLoading: false,
  totalRides: null,
  modalStatus: null,
}

const ridesSlice = createSlice({
  name: 'rides',
  initialState: INITIAL_STATE,
  reducers: {
    ridesRequest: (state, action) => {
      state.isLoading = true
    },
    ridesSuccess: (state, action) => {
      state.ridesList = action.payload.items
      state.totalRides = action.payload.total
      state.isLoading = false
    },
    ridesFailure: (state) => {
      state.isLoading = false
    },
    updateModal: (state, action) => {
      const current = state.ridesList.find((ride) => ride.id === action.payload.id)
      state.modalStatus = action.payload.action
      state.currentRide = current
    },
  },
})

export const { ridesRequest, ridesSuccess, ridesFailure, updateModal } = ridesSlice.actions

export default ridesSlice.reducer

export const epic = combineEpics(deliveriesRidesRequestEpic)

export function deliveriesRidesRequestEpic(action$) {
  return action$.ofType(ridesRequest.type).mergeMap((action) => {
    return (
      Observable.ajax(rides(action.payload))
        .mergeMap((res) =>
          Observable.of(
            ridesSuccess({ items: res.response['hydra:member'], total: res.response['hydra:totalItems'] }),
            ...(!res.response.length ? [] : []),
          ),
        )
        // @ts-ignore
        .catch((err) => {
          if (typeof err === 'object' && (err.response || {}).code === 401) {
            return Observable.of(authenticationDuck.refreshTokenRequest(action))
          }

          return Observable.of(ridesFailure())
        })
    )
  })
}

export const selectCurrentPageRides = (state: GlobalState) => state.rides.ridesList
export const selectTotalRides = (state: GlobalState) => state.rides.totalRides
export const selectModal = (state: GlobalState) => state.rides.modalStatus
export const selectRide = (state: GlobalState) => state.rides.currentRide
